<template>
  <div class="pa-4">
    <portal to="app-header">
      <router-link
        to="/debouncecode"
        class="ml-2"
      >
        参考防抖
      </router-link>
    </portal>
    <div class="d-flex">
      <h1>Throttle</h1>
      <span>{{ tip }}</span>
    </div>
    <p><code>throttle(func, wait)</code>每 wait 毫秒内最多只调用一次 func</p>
    <CodeHighlight :code="code" />
    <v-btn @click="runThrottle">
      运行Js方法
    </v-btn>
    <v-btn @click="runThrottle2">
      运行Vue方法
    </v-btn>
  </div>
</template>

<script>
import CodeHighlight from '@/modules/codehl/CodeHighlight.vue';

function throttle(func, wait) {
  // 上次触发时间戳
  let lastTime = 0;
  // 定时器
  let timer = null;

  return function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    let self = this;
    let args = arguments;
    // console.log('args', args);
    let nowTime = +new Date();

    const remainWaitTime = wait - (nowTime - lastTime);
    
    console.log('remainWaitTime', remainWaitTime, remainWaitTime <= 0);

    if (remainWaitTime <= 0) {
      lastTime = nowTime;
      func.apply(self, args);
    } else {
      timer = setTimeout(function () {
        lastTime = +new Date();
        func.apply(self, args);
        timer = null;
      }, remainWaitTime);
    }
  };
}

const fn = () => {
  console.log('runThrottle');
}

const run = throttle(fn, 2000);

export default {
  components: {
    CodeHighlight,
  },
  data() {
    return {
      tip: '',
      code: `function throttle(func, wait) {
  // 上次触发时间戳
  let lastTime = 0;
  // 定时器
  let timer = null;

  return function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    let self = this;
    let args = arguments;
    let nowTime = +new Date();

    const remainWaitTime = wait - (nowTime - lastTime);

    if (remainWaitTime <= 0) {
      lastTime = nowTime;
      func.apply(self, args);
    } else {
      timer = setTimeout(function () {
        lastTime = +new Date();
        func.apply(self, args);
        timer = null;
      }, remainWaitTime);
    }
  };
}`,
runtask: null,
    }
  },

  mounted() {
    this.runtask = throttle(this.fn2, 2000);
  },

  methods: {
    runThrottle() {
      run();
    },
    fn2() {
      this.tip = '完成, 2000ms内最多调用1次';
      console.log('runThrottle2');
    },
    runThrottle2() {
      this.tip = '运行中...';
      this.runtask();
    }
  },
}
</script>

<style scoped>

</style>